import { COUNTRY_TO_CHINESE } from "./orders_render.js";

/**
 * Efast Workbench - 工具函数与全局数据
 * 从 sales_logic.js 拆分
 */

function countryToChinese(countryInput) {
    if (!countryInput) return "未知";
    let country = countryInput.trim();
    
    const mapped = COUNTRY_TO_CHINESE[country] || COUNTRY_TO_CHINESE[country.charAt(0).toUpperCase() + country.slice(1).toLowerCase()] || "";
    if (mapped) return mapped;
    
    // 防御性：截取前三个字母转大写
    return country.length > 12 ? country.substring(0, 12) + "..." : country;
}

// 国家全名到2位代码的映射（覆盖主要外贸目标国）
const COUNTRY_NAME_TO_CODE = {
    "Ghana":"GH","Senegal":"SN","Mali":"ML","Nigeria":"NG","Kenya":"KE",
    "Tanzania":"TZ","Ethiopia":"ET","Uganda":"UG","Cameroon":"CM","Ivory Coast":"CI",
    "South Africa":"ZA","Egypt":"EG","Morocco":"MA","Tunisia":"TN","Algeria":"DZ",
    "Germany":"DE","France":"FR","United Kingdom":"GB","UK":"GB","Italy":"IT",
    "Spain":"ES","Netherlands":"NL","Belgium":"BE","Poland":"PL","Sweden":"SE",
    "Norway":"NO","Denmark":"DK","Finland":"FI","Portugal":"PT","Austria":"AT",
    "Switzerland":"CH","Czech Republic":"CZ","Romania":"RO","Hungary":"HU",
    "United States":"US","USA":"US","Canada":"CA","Mexico":"MX","Brazil":"BR",
    "Argentina":"AR","Colombia":"CO","Chile":"CL","Peru":"PE",
    "Australia":"AU","New Zealand":"NZ","Japan":"JP","South Korea":"KR","Korea":"KR",
    "India":"IN","Pakistan":"PK","Bangladesh":"BD","Sri Lanka":"LK",
    "Saudi Arabia":"SA","UAE":"AE","United Arab Emirates":"AE","Qatar":"QA",
    "Kuwait":"KW","Bahrain":"BH","Oman":"OM","Jordan":"JO","Israel":"IL",
    "Turkey":"TR","Russia":"RU","Ukraine":"UA","Kazakhstan":"KZ",
    "Indonesia":"ID","Malaysia":"MY","Thailand":"TH","Vietnam":"VN",
    "Philippines":"PH","Singapore":"SG","Myanmar":"MM","Cambodia":"KH",
    "China":"CN","Taiwan":"TW","Hong Kong":"HK"
};


function countryToFlag(countryInput) {
    if (!countryInput) return "";
    let code = countryInput.trim();

    // 如果已经是2位代码
    if (code.length === 2) {
        code = code.toUpperCase();
    } else {
        // 使用正则对空空白字符执行安全切分，过滤掉 empty 节点，100% 避免 w[0] 出现 undefined
        const words = code.split(/\s+/).filter(Boolean);
        const mappedName = words.map(w => {
            if (!w) return "";
            return w[0].toUpperCase() + w.slice(1).toLowerCase();
        }).join(" ");
        
        code = COUNTRY_NAME_TO_CODE[code] || COUNTRY_NAME_TO_CODE[mappedName] || "";
    }

    if (!code || code.length !== 2) return "";
    return [...code.toUpperCase()].map(c => String.fromCodePoint(c.charCodeAt(0) + 127397)).join("");
}

function toggleTodo(todoId) {
    const todoEl = document.getElementById(`chk-todo-${todoId}`);
    if (todoEl && todoEl.checked) {
        todoEl.nextElementSibling.classList.add("completed");
    } else if (todoEl) {
        todoEl.nextElementSibling.classList.remove("completed");
    }
    updateTodoBadge();
}


function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    if (typeof str !== 'string') str = String(str);
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function showToast(title, msg, type) {
    var existing = document.getElementById('efast-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'efast-toast';
    toast.style.cssText = 'position:fixed;top:20px;right:20px;z-index:99999;background:#1e293b;color:#f8fafc;border:1px solid #334155;border-radius:8px;padding:12px 18px;min-width:280px;box-shadow:0 10px 40px rgba(0,0,0,0.5);font-family:-apple-system,BlinkMacSystemFont,sans-serif;animation:efastSlideIn 0.3s ease;';
    var icon = type === 'error' ? '❌' : '✅';
    toast.innerHTML = '<div style="display:flex;align-items:flex-start;gap:10px;"><span style="font-size:1.2rem;">' + icon + '</span><div><div style="font-weight:700;margin-bottom:4px;">' + title + '</div><div style="font-size:0.8rem;color:#94a3b8;line-height:1.5;">' + msg + '</div></div></div>';
    document.body.appendChild(toast);
    setTimeout(function() {
        toast.style.opacity = '0';
        toast.style.transition = 'opacity 0.3s';
        setTimeout(function() { if (toast.parentNode) toast.remove(); }, 300);
    }, 4000);
}

// CSS动画注入（只一次）
if (!document.getElementById('efast-toast-style')) {
    var style = document.createElement('style');
    style.id = 'efast-toast-style';
    style.textContent = '@keyframes efastSlideIn{from{transform:translateX(100px);opacity:0}to{transform:translateX(0);opacity:1}}';
    document.head.appendChild(style);
}

function getElapsedHtml(timestamp, isUnread) {
    if (!timestamp) return { html: "", isOver24h: false };
    const now = Date.now();
    const elapsedMs = now - timestamp;
    const hours = elapsedMs / (3600 * 1000);
    
    let timeStr = "";
    if (elapsedMs < 0) {
        timeStr = "刚刚";
    } else if (elapsedMs < 60 * 1000) {
        timeStr = "刚刚";
    } else if (elapsedMs < 60 * 60 * 1000) {
        const mins = Math.floor(elapsedMs / (60 * 1000));
        timeStr = `${mins}分钟前`;
    } else if (elapsedMs < 24 * 3600 * 1000) {
        const h = Math.floor(elapsedMs / (3600 * 1000));
        const m = Math.floor((elapsedMs % (3600 * 1000)) / (60 * 1000));
        timeStr = `${h}小时${m}分钟前`;
    } else {
        const days = Math.floor(elapsedMs / (24 * 3600 * 1000));
        timeStr = `${days}天前`;
    }
    
    const isOver24h = hours >= 24;
    
    // 状态角标：已读与未读
    const statusBadge = isUnread 
        ? `<span class="inquiry-status-badge unread" style="background:#ef4444; color:#fff; padding:2px 6px; border-radius:4px; font-size:0.75rem; margin-left:0.5rem; font-weight:bold;">未读</span>`
        : `<span class="inquiry-status-badge read" style="background:#94a3b8; color:#fff; padding:2px 6px; border-radius:4px; font-size:0.75rem; margin-left:0.5rem;">已读</span>`;
        
    let elapsedStyle = "";
    if (isOver24h) {
        elapsedStyle = `color: #ef4444; font-weight: bold; background: #fee2e2; padding: 2px 6px; border-radius: 4px; border: 1px solid #fecaca;`;
    } else {
        elapsedStyle = `color: #f59e0b; font-weight: bold; background: #fef3c7; padding: 2px 6px; border-radius: 4px; border: 1px solid #fde68a;`;
    }
    
    const warningLabel = isOver24h ? `过了 ${timeStr} ⚠️` : `过了 ${timeStr}`;
    
    return {
        html: `<span class="time-limit" style="${elapsedStyle}"><i class="fas fa-clock"></i> ${warningLabel}</span>${statusBadge}`,
        isOver24h
    };
}


function parseAlibabaTime(timeStr) {
    const now = new Date();
    timeStr = (timeStr || "").trim();
    if (!timeStr) return now.getTime();
    
    // 1. HH:MM:SS 或 HH:MM
    const hmsMatch = timeStr.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (hmsMatch) {
        const h = parseInt(hmsMatch[1]);
        const m = parseInt(hmsMatch[2]);
        const s = hmsMatch[3] ? parseInt(hmsMatch[3]) : 0;
        const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, s);
        if (d > now) {
            d.setDate(d.getDate() - 1);
        }
        return d.getTime();
    }
    
    // 2. 昨天 / Yesterday
    if (/yesterday|昨天/i.test(timeStr)) {
        const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 12, 0, 0);
        return d.getTime();
    }
    
    // 3. X天前 / X days ago
    const daysAgoMatch = timeStr.match(/(\d+)\s*(days? ago|天前)/i);
    if (daysAgoMatch) {
        const days = parseInt(daysAgoMatch[1]);
        const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - days, 12, 0, 0);
        return d.getTime();
    }

    // 4. X分钟前 / Xm ago
    const minsAgoMatch = timeStr.match(/(\d+)\s*(m|mins?|minutes?|分钟前)/i);
    if (minsAgoMatch) {
        const mins = parseInt(minsAgoMatch[1]);
        return now.getTime() - mins * 60 * 1000;
    }
    
    // 5. X小时前 / Xh ago
    const hoursAgoMatch = timeStr.match(/(\d+)\s*(h|hours?|小时前)/i);
    if (hoursAgoMatch) {
        const hours = parseInt(hoursAgoMatch[1]);
        return now.getTime() - hours * 60 * 60 * 1000;
    }
    
    // 6. 年-月-日 (YYYY-MM-DD 或 YYYY/MM/DD)
    const fullDateMatch = timeStr.match(/(\d{4})[-/](\d{2})[-/](\d{2})/);
    if (fullDateMatch) {
        return new Date(fullDateMatch[1], parseInt(fullDateMatch[2]) - 1, fullDateMatch[3]).getTime();
    }
    
    // 7. 月-日 (MM-DD 或 MM/DD)
    const shortDateMatch = timeStr.match(/(\d{2})[-/](\d{2})/);
    if (shortDateMatch) {
        const currentYear = now.getFullYear();
        let targetMonth = parseInt(shortDateMatch[1]) - 1;
        let targetDay = parseInt(shortDateMatch[2]);
        const d = new Date(currentYear, targetMonth, targetDay);
        if (d > now) {
            d.setFullYear(currentYear - 1);
        }
        return d.getTime();
    }
    
    return now.getTime();
}

/**
 * 依据时间戳与已读/未读状态生成带警示、样式标签的 HTML
 */



/**
 * 将阿里巴巴消息列表返回的各种时间文本 (10:05, 昨天, 06-05, 10m ago等) 转换为高精度 Unix 毫秒时间戳
 */


// ===== 全局客户信息气泡 =====
var _crmLoaded = false;
function preloadCRMForTooltips() {
    if (_crmLoaded) return;
    fetch("/api/customers", { headers: { "Authorization": "Bearer " + (typeof Auth !== "undefined" && Auth.getToken ? Auth.getToken() : "") } })
        .then(function(r) { if (r.ok) return r.json(); return { customers: [] }; })
        .then(function(data) {
            window._crmCustomers = data.customers || [];
            _crmLoaded = true;
        }).catch(function() { window._crmCustomers = []; });
}
function loadBuyerTooltip(el, buyerName, buyerPhone) {
    preloadCRMForTooltips();
    var crm = window._crmCustomers || [];
    var match = crm.find(function(c) { return c.contact === buyerName; });
    var phone = (match && match.phone) ? match.phone : ((buyerPhone && buyerPhone !== "undefined" && buyerPhone !== "") ? buyerPhone : "--");
    var whatsapp = (match && match.whatsapp) ? match.whatsapp : "--";
    var email = (match && match.email) ? match.email : "--";
    el.title = "电话: " + phone + "\nWhatsApp: " + whatsapp + "\n邮箱: " + email;
}
// Global delegated listener: any element with data-buyer gets tooltip
document.addEventListener("mouseover", function(e) {
    var el = e.target.closest("[data-buyer]");
    if (!el) return;
    if (el._tooltipLoaded) return;
    el._tooltipLoaded = true;
    var name = el.getAttribute("data-buyer");
    var phone = el.getAttribute("data-phone") || "";
    loadBuyerTooltip(el, name, phone);
});
preloadCRMForTooltips();

export { showToast, getElapsedHtml, loadBuyerTooltip, countryToChinese, escapeHtml };
